export const getId = (list, shard, scopeId) => {
    var _a;
    const scopedId = `${scopeId}-${shard.getId()}`;
    return ((_a = list.get(scopeId || "")) === null || _a === void 0 ? void 0 : _a.find((i) => i.getScope() === scopeId))
        ? scopedId
        : shard.getId();
};
//# sourceMappingURL=getId.js.map